module.exports = __webpack_public_path__ + "img/Phone_06.063acee2.jpg";